module.exports = __webpack_public_path__ + "img/jiabin1.bb481416.png";